import gql from 'graphql-tag';

import {
  FirstToDonateEnrolmentFragment,
  PageType,
} from '../../types/__generated__';
import { PageMetaContext } from '../context';
import { useNotNullableContext } from './useNotNullableContext';
import usePageQuery, { buildQuery } from './usePageQuery';

const FRAGMENT = buildQuery(gql`
  fragment FirstToDonateEnrolment on Page {
    id
    targetWithCurrency {
      currencyCode
      value
    }
    donationSummary {
      totalAmount {
        value
      }
    }
  }
`);

export function useShouldDisplayFirstToDonateTotals(): boolean {
  const { pageType } = useNotNullableContext(PageMetaContext);

  const { data = null } = usePageQuery<FirstToDonateEnrolmentFragment>(
    FRAGMENT,
    {
      notifyOnNetworkStatusChange: true,
    },
  );

  if (!data) return false;

  const { targetWithCurrency, donationSummary } = data;

  const targetValue = targetWithCurrency?.value;
  const donationValue = donationSummary?.totalAmount?.value ?? 0;

  return !(
    pageType.toUpperCase() !== PageType.Fundraising ||
    !targetValue ||
    donationValue > 0
  );
}
